import { Button, ButtonProps } from '@sparemin/blockhead';
import React from 'react';
import Tooltip from 'components/Tooltip';
import { ClipSelectionMode } from 'containers/ProjectWizards/ClipVideoStep';
import { block } from '../utils';

export type ClipVideoStepContinueButtonProps = Pick<ButtonProps, 'onPress'> & {
  canTranscribe?: boolean;
  clipSelectionMode: ClipSelectionMode;
  outOfTimeMessage?: string;
};

const ClipVideoStepContinueButton: React.FC<ClipVideoStepContinueButtonProps> = ({
  canTranscribe,
  clipSelectionMode,
  onPress,
  outOfTimeMessage,
}) => {
  return (
    <Tooltip
      content={outOfTimeMessage}
      id="video-clip-tooltip"
      placement="top"
      show={!canTranscribe ? undefined : false}
    >
      <Button
        className={block('captions-button')}
        isDisabled={!canTranscribe}
        fluid
        onPress={onPress}
        variant="solid"
      >
        {clipSelectionMode === 'clip'
          ? 'continue with this clip'
          : 'continue with full episode'}
      </Button>
    </Tooltip>
  );
};

export default ClipVideoStepContinueButton;
